module.exports = __webpack_public_path__ + "static/img/about_01.4da2781.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_01.jpg
// module id = tNfW
// module chunks = 1